/* Brand mark: gold-gradient star on a cobalt rounded-square tile (the
   ".gstar" mark from the LIGHT marketing site) + "Rhody Reviews" wordmark
   in DM Sans ("Reviews" in the UI blue accent). Self-contained classes
   (.brand-rr / .gstar / .brand-rr__name) so it renders correctly on both
   the light auth screens and the dark dashboard sidebar. The .gstar CSS is
   ported from the marketing global.css and lives in styles/auth.css.

   The mark is a plain anchor to the public marketing site
   (https://rhodyreviews.com). Marketing is a SEPARATE site/origin from the
   app, so a real <a> (not a react-router Link) is correct. Steve asked to be
   able to click the logo to get back to the website. (2026-06-26, Corbato.) */

export function BrandMark({ size = 30 }: { size?: number }) {
  return (
    <a
      className="brand-rr"
      href="https://rhodyreviews.com"
      aria-label="Rhody Reviews home"
      title="Back to rhodyreviews.com"
    >
      <span className="gstar" style={{ width: size, height: size }} aria-hidden="true" />
      <div className="brand-rr__name">Rhody <b>Reviews</b></div>
    </a>
  );
}
